import { faro } from '@grafana/faro-web-sdk';

type PrimitiveValue = string | number | boolean | null | undefined;
export type ContextAttributes = Record<string, PrimitiveValue>;

const isClient = () => typeof window !== 'undefined';

const toStringAttributes = (attributes?: ContextAttributes): Record<string, string> | undefined => {
  if (!attributes) {
    return undefined;
  }
  const next: Record<string, string> = {};
  for (const [key, value] of Object.entries(attributes)) {
    if (value !== null && value !== undefined) {
      next[key] = String(value);
    }
  }
  return Object.keys(next).length ? next : undefined;
};

const normalizeError = (error: unknown): Error => {
  if (error instanceof Error) return error;
  if (typeof error === 'string') return new Error(error);
  return new Error('Unknown frontend error');
};

export const trackFrontendEvent = (name: string, attributes?: ContextAttributes, domain = 'frontend') => {
  if (!isClient()) return;
  faro.api.pushEvent(name, toStringAttributes(attributes), domain);
};

export const logFrontendError = (error: unknown, context?: ContextAttributes) => {
  if (!isClient()) return;
  faro.api.pushError(normalizeError(error), { context: toStringAttributes(context) });
};

export const startFrontendUserAction = (
  name: string,
  attributes?: ContextAttributes,
): { end: () => void } | undefined => {
  if (!isClient()) return undefined;
  return faro.api.startUserAction?.(name, toStringAttributes(attributes)) as { end: () => void } | undefined;
};
